module.exports = __webpack_public_path__ + "img/lecture_back_btn.a0cb5ec4.svg";